<template>
  <div class="flex flex-col h-full ">
    <div class="grow overflow-y-auto py-4">
      <div class="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-4">
        <ColorExplanation
          v-for="(color, key) in weatherColors"
          :key="key"
          :color="color"
          :colorName="$t(`colorGuide.${key}`)"
          :explanation="$t(`colorGuide.${key}_explanation`)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import ColorExplanation from '@/components/ColorExplanation.vue';
import { SKY_COLORS } from '@/utils/colors.js';

const weatherColors = {
  clear: SKY_COLORS.clear,
  partly_cloudy: SKY_COLORS.partly_cloudy,
  cloudy: SKY_COLORS.cloudy,
  scattered_rain: SKY_COLORS.scattered_rain,
  rain: SKY_COLORS.rain,
  scattered_snow: SKY_COLORS.scattered_snow,
  snow: SKY_COLORS.snow,
};
</script>

